import { Builder, withChildren } from '@builder.io/react'

import { ContentInfoLandmark } from './ContentInfoLandmark'

Builder.registerComponent(withChildren(ContentInfoLandmark), {
  name: 'ContentInfoLandmark',
  canHaveChildren: true,
  noWrap: true,
  hideFromInsertMenu: true,
})
